import { Component, computed, inject, model } from '@angular/core';
import { ShowUserFacade } from '../../../../../Facades/Intune/show-user.facade';
import { AvListComponent } from '../../../../Shared/Components/av-list/av-list.component';
import { CommonModule } from '@angular/common';
import { LicenseDetails } from '../../../../../Models/Intune/intune-user.model';
import type { AvListItem } from '../../../../Shared/Interfaces/av-list.interface';


import { AvTableCard } from '../../../../Shared/Components/av-table-card/av-table-card.component';
import type { AvTableColumn, AvTableRow } from '../../../../Shared/Interfaces/av-table-card.interface';
import { AvContentContainerComponent } from '../../../../Shared/Components/av-content-container/av-content-container.component';
import { AvLoadingItemComponent } from '../../../../Shared/Components/av-loading-item/av-loading-item.component';

@Component({
  selector: 'app-licenses',
  imports: [CommonModule, AvListComponent, AvTableCard, AvContentContainerComponent, AvLoadingItemComponent],
  standalone: true,
  templateUrl: './licenses.component.html',
  styleUrls: ['./licenses.component.scss'],
})
export class LicensesComponent {
  private readonly _showUserFacade = inject(ShowUserFacade);
  readonly licenses = computed<LicenseDetails[]>(() => this._showUserFacade.licenses());
  readonly isLoading = computed(() => this._showUserFacade.licensesStatus() === 'loading');


  readonly licenseItems = computed<AvListItem[]>(() =>
    this.licenses().map((license: LicenseDetails) => ({
      label: license.displayName ?? license.skuPartNumber ?? '',
      id: license.skuPartNumber ?? license.id ?? '',
    }))
  );

  readonly selectedLicenseId = model<string | null>(null);

  readonly selectedLicense = computed<LicenseDetails | null>(() => {
    const id = this.selectedLicenseId();
    if (id == null || id === '') return null;
    return this.licenses().find((l) => (l.skuPartNumber ?? l.id) === id) ?? null;
  });

  readonly selectedLicenseColumns = computed<AvTableColumn[]>(() => [
    { key: 'displayName', label: 'app.licenses.table.display_name', sortable: true },
    { key: 'servicePlanType', label: 'app.licenses.table.service_plan_type', sortable: true },
    { key: 'provisioningStatus', label: 'app.licenses.table.provisioning_status', sortable: true },
    { key: 'appliesTo', label: 'app.licenses.table.applies_to', sortable: true },
  ]);

  readonly selectedLicenseRows = computed<AvTableRow[]>(() => {
    const license = this.selectedLicense();
    const plans = license?.servicePlans ?? [];
    return plans.map((plan) => ({
      displayName: plan.displayName ?? '',
      servicePlanType: plan.servicePlanType ?? '',
      provisioningStatus: plan.provisioningStatus ?? '',
      appliesTo: plan.appliesTo ?? '',
    }));
  });
}
